﻿import React from 'react';
import { useBlazeSlider } from 'react-blaze-slider'
import {ConnectedProductModel} from "../../product-models";
import RelatedProduct from "./RelatedProduct";

interface RelatedProductProps {
    products: ConnectedProductModel[];
    sectionTitle: string;
}

const RelatedProducts = ({ products, sectionTitle }:RelatedProductProps) => {

    if(products == undefined || products.length == 0) return null;

    const sliderRef = useBlazeSlider({
        all: {
            slidesToShow: 6,
            slidesToScroll: 5,
            enablePagination: true,
        },
        '(max-width: 800px)': {
            slidesToShow: 4,
        },
        '(max-width: 500px)': {
            slidesToShow: 2,
        },
        '(max-width: 400px)': {
            slidesToShow: 1,
        },
    })
    
  return (
    <div className="related-products">
        <div className="onepcssgrid-1300 onepcssblockgrid">
            <div className="onerow">
                <div className="col12 last">
                    <h2 className="related-products__title">{sectionTitle}</h2>

                    <div className="blaze-slider" ref={sliderRef}>
                        <div className="blaze-container">
                            <div className="blaze-track-container">
                                <div className="blaze-track">
                                    {products.map((product, index) => {
                                        return <RelatedProduct 
                                            ProductName={product.ProductName} 
                                            ThumbUrl={product.ThumbUrl} 
                                            key={product.ProductName} 
                                        />
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="controls">
                            <button className="blaze-prev blaze-next-prev">prev</button>
                            <button className="blaze-next blaze-next-prev">next</button>
                        </div>
                        <div className="blaze-pagination"></div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
  )
}

export default RelatedProducts;